// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v7.35.0
// source: watchlist.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { Security, SecurityExpression } from "./security";

export const protobufPackage = "com.tick2trade.api.watchlist";

export interface Watchlist {
  id: string;
  name: string;
  watchlistItems: Watchlist_WatchlistItem[];
  default: boolean;
  type: Watchlist_Type;
  shareType: Watchlist_ShareType;
  shareId: string;
  priority: number;
  screenerId?: string | undefined;
  isDeleted: boolean;
  groupBy?: Watchlist_GroupBy | undefined;
  groupView?: boolean | undefined;
}

export enum Watchlist_ShareType {
  SHARE_TYPE_UNKNOWN = 0,
  USER = 1,
  SHARED = 2,
  COMMUNITY = 3,
  UNRECOGNIZED = -1,
}

export function watchlist_ShareTypeFromJSON(object: any): Watchlist_ShareType {
  switch (object) {
    case 0:
    case "SHARE_TYPE_UNKNOWN":
      return Watchlist_ShareType.SHARE_TYPE_UNKNOWN;
    case 1:
    case "USER":
      return Watchlist_ShareType.USER;
    case 2:
    case "SHARED":
      return Watchlist_ShareType.SHARED;
    case 3:
    case "COMMUNITY":
      return Watchlist_ShareType.COMMUNITY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Watchlist_ShareType.UNRECOGNIZED;
  }
}

export function watchlist_ShareTypeToJSON(object: Watchlist_ShareType): string {
  switch (object) {
    case Watchlist_ShareType.SHARE_TYPE_UNKNOWN:
      return "SHARE_TYPE_UNKNOWN";
    case Watchlist_ShareType.USER:
      return "USER";
    case Watchlist_ShareType.SHARED:
      return "SHARED";
    case Watchlist_ShareType.COMMUNITY:
      return "COMMUNITY";
    case Watchlist_ShareType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Watchlist_Type {
  TYPE_UNKNOWN = 0,
  LIST = 1,
  SCREENER = 2,
  REFERENCE = 3,
  UNRECOGNIZED = -1,
}

export function watchlist_TypeFromJSON(object: any): Watchlist_Type {
  switch (object) {
    case 0:
    case "TYPE_UNKNOWN":
      return Watchlist_Type.TYPE_UNKNOWN;
    case 1:
    case "LIST":
      return Watchlist_Type.LIST;
    case 2:
    case "SCREENER":
      return Watchlist_Type.SCREENER;
    case 3:
    case "REFERENCE":
      return Watchlist_Type.REFERENCE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Watchlist_Type.UNRECOGNIZED;
  }
}

export function watchlist_TypeToJSON(object: Watchlist_Type): string {
  switch (object) {
    case Watchlist_Type.TYPE_UNKNOWN:
      return "TYPE_UNKNOWN";
    case Watchlist_Type.LIST:
      return "LIST";
    case Watchlist_Type.SCREENER:
      return "SCREENER";
    case Watchlist_Type.REFERENCE:
      return "REFERENCE";
    case Watchlist_Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Watchlist_GroupBy {
  GROUP_BY_UNKNOWN = 0,
  MARKET_CAPITALISATION = 1,
  SECTOR = 2,
  INDUSTRY = 3,
  UNRECOGNIZED = -1,
}

export function watchlist_GroupByFromJSON(object: any): Watchlist_GroupBy {
  switch (object) {
    case 0:
    case "GROUP_BY_UNKNOWN":
      return Watchlist_GroupBy.GROUP_BY_UNKNOWN;
    case 1:
    case "MARKET_CAPITALISATION":
      return Watchlist_GroupBy.MARKET_CAPITALISATION;
    case 2:
    case "SECTOR":
      return Watchlist_GroupBy.SECTOR;
    case 3:
    case "INDUSTRY":
      return Watchlist_GroupBy.INDUSTRY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Watchlist_GroupBy.UNRECOGNIZED;
  }
}

export function watchlist_GroupByToJSON(object: Watchlist_GroupBy): string {
  switch (object) {
    case Watchlist_GroupBy.GROUP_BY_UNKNOWN:
      return "GROUP_BY_UNKNOWN";
    case Watchlist_GroupBy.MARKET_CAPITALISATION:
      return "MARKET_CAPITALISATION";
    case Watchlist_GroupBy.SECTOR:
      return "SECTOR";
    case Watchlist_GroupBy.INDUSTRY:
      return "INDUSTRY";
    case Watchlist_GroupBy.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Watchlist_WatchlistItem {
  id?: number | undefined;
  type: Watchlist_WatchlistItem_Type;
  security?: Security | undefined;
  securityExpression?: SecurityExpression | undefined;
  sectionName?: string | undefined;
  priority?: number | undefined;
  group?: string | undefined;
}

export enum Watchlist_WatchlistItem_Type {
  TYPE_UNKNOWN = 0,
  SECURITY = 1,
  EXPRESSION = 2,
  SECTION = 3,
  UNRECOGNIZED = -1,
}

export function watchlist_WatchlistItem_TypeFromJSON(object: any): Watchlist_WatchlistItem_Type {
  switch (object) {
    case 0:
    case "TYPE_UNKNOWN":
      return Watchlist_WatchlistItem_Type.TYPE_UNKNOWN;
    case 1:
    case "SECURITY":
      return Watchlist_WatchlistItem_Type.SECURITY;
    case 2:
    case "EXPRESSION":
      return Watchlist_WatchlistItem_Type.EXPRESSION;
    case 3:
    case "SECTION":
      return Watchlist_WatchlistItem_Type.SECTION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Watchlist_WatchlistItem_Type.UNRECOGNIZED;
  }
}

export function watchlist_WatchlistItem_TypeToJSON(object: Watchlist_WatchlistItem_Type): string {
  switch (object) {
    case Watchlist_WatchlistItem_Type.TYPE_UNKNOWN:
      return "TYPE_UNKNOWN";
    case Watchlist_WatchlistItem_Type.SECURITY:
      return "SECURITY";
    case Watchlist_WatchlistItem_Type.EXPRESSION:
      return "EXPRESSION";
    case Watchlist_WatchlistItem_Type.SECTION:
      return "SECTION";
    case Watchlist_WatchlistItem_Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface ToggleWatchlistGroupViewRequest {
  groupView: boolean;
}

export interface WatchlistItems {
  watchlistItems: Watchlist_WatchlistItem[];
}

export interface UserWatchlists {
  watchlists: Watchlist[];
}

export interface ReorderWatchlistRequest {
  watchlistItems: Watchlist_WatchlistItem[];
}

export interface ContainsWatchlistItemRequest {
  watchlistIds: string[];
  securityOrExpression: string;
}

export interface ContainsWatchlistItemResponse {
  records: { [key: string]: boolean };
}

export interface ContainsWatchlistItemResponse_RecordsEntry {
  key: string;
  value: boolean;
}

function createBaseWatchlist(): Watchlist {
  return {
    id: "",
    name: "",
    watchlistItems: [],
    default: false,
    type: 0,
    shareType: 0,
    shareId: "",
    priority: 0,
    screenerId: undefined,
    isDeleted: false,
    groupBy: undefined,
    groupView: undefined,
  };
}

export const Watchlist = {
  encode(message: Watchlist, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    for (const v of message.watchlistItems) {
      Watchlist_WatchlistItem.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    if (message.default !== false) {
      writer.uint32(40).bool(message.default);
    }
    if (message.type !== 0) {
      writer.uint32(48).int32(message.type);
    }
    if (message.shareType !== 0) {
      writer.uint32(56).int32(message.shareType);
    }
    if (message.shareId !== "") {
      writer.uint32(66).string(message.shareId);
    }
    if (message.priority !== 0) {
      writer.uint32(73).double(message.priority);
    }
    if (message.screenerId !== undefined) {
      writer.uint32(82).string(message.screenerId);
    }
    if (message.isDeleted !== false) {
      writer.uint32(88).bool(message.isDeleted);
    }
    if (message.groupBy !== undefined) {
      writer.uint32(96).int32(message.groupBy);
    }
    if (message.groupView !== undefined) {
      writer.uint32(104).bool(message.groupView);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Watchlist {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWatchlist();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.watchlistItems.push(Watchlist_WatchlistItem.decode(reader, reader.uint32()));
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.default = reader.bool();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.shareType = reader.int32() as any;
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.shareId = reader.string();
          continue;
        case 9:
          if (tag !== 73) {
            break;
          }

          message.priority = reader.double();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.screenerId = reader.string();
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.isDeleted = reader.bool();
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.groupBy = reader.int32() as any;
          continue;
        case 13:
          if (tag !== 104) {
            break;
          }

          message.groupView = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Watchlist {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      watchlistItems: globalThis.Array.isArray(object?.watchlistItems)
        ? object.watchlistItems.map((e: any) => Watchlist_WatchlistItem.fromJSON(e))
        : [],
      default: isSet(object.default) ? globalThis.Boolean(object.default) : false,
      type: isSet(object.type) ? watchlist_TypeFromJSON(object.type) : 0,
      shareType: isSet(object.shareType) ? watchlist_ShareTypeFromJSON(object.shareType) : 0,
      shareId: isSet(object.shareId) ? globalThis.String(object.shareId) : "",
      priority: isSet(object.priority) ? globalThis.Number(object.priority) : 0,
      screenerId: isSet(object.screenerId) ? globalThis.String(object.screenerId) : undefined,
      isDeleted: isSet(object.isDeleted) ? globalThis.Boolean(object.isDeleted) : false,
      groupBy: isSet(object.groupBy) ? watchlist_GroupByFromJSON(object.groupBy) : undefined,
      groupView: isSet(object.groupView) ? globalThis.Boolean(object.groupView) : undefined,
    };
  },

  toJSON(message: Watchlist): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.watchlistItems?.length) {
      obj.watchlistItems = message.watchlistItems.map((e) => Watchlist_WatchlistItem.toJSON(e));
    }
    if (message.default !== false) {
      obj.default = message.default;
    }
    if (message.type !== 0) {
      obj.type = watchlist_TypeToJSON(message.type);
    }
    if (message.shareType !== 0) {
      obj.shareType = watchlist_ShareTypeToJSON(message.shareType);
    }
    if (message.shareId !== "") {
      obj.shareId = message.shareId;
    }
    if (message.priority !== 0) {
      obj.priority = message.priority;
    }
    if (message.screenerId !== undefined) {
      obj.screenerId = message.screenerId;
    }
    if (message.isDeleted !== false) {
      obj.isDeleted = message.isDeleted;
    }
    if (message.groupBy !== undefined) {
      obj.groupBy = watchlist_GroupByToJSON(message.groupBy);
    }
    if (message.groupView !== undefined) {
      obj.groupView = message.groupView;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Watchlist>, I>>(base?: I): Watchlist {
    return Watchlist.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Watchlist>, I>>(object: I): Watchlist {
    const message = createBaseWatchlist();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.watchlistItems = object.watchlistItems?.map((e) => Watchlist_WatchlistItem.fromPartial(e)) || [];
    message.default = object.default ?? false;
    message.type = object.type ?? 0;
    message.shareType = object.shareType ?? 0;
    message.shareId = object.shareId ?? "";
    message.priority = object.priority ?? 0;
    message.screenerId = object.screenerId ?? undefined;
    message.isDeleted = object.isDeleted ?? false;
    message.groupBy = object.groupBy ?? undefined;
    message.groupView = object.groupView ?? undefined;
    return message;
  },
};

function createBaseWatchlist_WatchlistItem(): Watchlist_WatchlistItem {
  return {
    id: undefined,
    type: 0,
    security: undefined,
    securityExpression: undefined,
    sectionName: undefined,
    priority: undefined,
    group: undefined,
  };
}

export const Watchlist_WatchlistItem = {
  encode(message: Watchlist_WatchlistItem, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== undefined) {
      writer.uint32(8).int32(message.id);
    }
    if (message.type !== 0) {
      writer.uint32(16).int32(message.type);
    }
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(26).fork()).ldelim();
    }
    if (message.securityExpression !== undefined) {
      SecurityExpression.encode(message.securityExpression, writer.uint32(42).fork()).ldelim();
    }
    if (message.sectionName !== undefined) {
      writer.uint32(58).string(message.sectionName);
    }
    if (message.priority !== undefined) {
      writer.uint32(81).double(message.priority);
    }
    if (message.group !== undefined) {
      writer.uint32(90).string(message.group);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Watchlist_WatchlistItem {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWatchlist_WatchlistItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.id = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.securityExpression = SecurityExpression.decode(reader, reader.uint32());
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.sectionName = reader.string();
          continue;
        case 10:
          if (tag !== 81) {
            break;
          }

          message.priority = reader.double();
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.group = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Watchlist_WatchlistItem {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : undefined,
      type: isSet(object.type) ? watchlist_WatchlistItem_TypeFromJSON(object.type) : 0,
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      securityExpression: isSet(object.securityExpression)
        ? SecurityExpression.fromJSON(object.securityExpression)
        : undefined,
      sectionName: isSet(object.sectionName) ? globalThis.String(object.sectionName) : undefined,
      priority: isSet(object.priority) ? globalThis.Number(object.priority) : undefined,
      group: isSet(object.group) ? globalThis.String(object.group) : undefined,
    };
  },

  toJSON(message: Watchlist_WatchlistItem): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = Math.round(message.id);
    }
    if (message.type !== 0) {
      obj.type = watchlist_WatchlistItem_TypeToJSON(message.type);
    }
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.securityExpression !== undefined) {
      obj.securityExpression = SecurityExpression.toJSON(message.securityExpression);
    }
    if (message.sectionName !== undefined) {
      obj.sectionName = message.sectionName;
    }
    if (message.priority !== undefined) {
      obj.priority = message.priority;
    }
    if (message.group !== undefined) {
      obj.group = message.group;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Watchlist_WatchlistItem>, I>>(base?: I): Watchlist_WatchlistItem {
    return Watchlist_WatchlistItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Watchlist_WatchlistItem>, I>>(object: I): Watchlist_WatchlistItem {
    const message = createBaseWatchlist_WatchlistItem();
    message.id = object.id ?? undefined;
    message.type = object.type ?? 0;
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.securityExpression = (object.securityExpression !== undefined && object.securityExpression !== null)
      ? SecurityExpression.fromPartial(object.securityExpression)
      : undefined;
    message.sectionName = object.sectionName ?? undefined;
    message.priority = object.priority ?? undefined;
    message.group = object.group ?? undefined;
    return message;
  },
};

function createBaseToggleWatchlistGroupViewRequest(): ToggleWatchlistGroupViewRequest {
  return { groupView: false };
}

export const ToggleWatchlistGroupViewRequest = {
  encode(message: ToggleWatchlistGroupViewRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.groupView !== false) {
      writer.uint32(8).bool(message.groupView);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ToggleWatchlistGroupViewRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToggleWatchlistGroupViewRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.groupView = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ToggleWatchlistGroupViewRequest {
    return { groupView: isSet(object.groupView) ? globalThis.Boolean(object.groupView) : false };
  },

  toJSON(message: ToggleWatchlistGroupViewRequest): unknown {
    const obj: any = {};
    if (message.groupView !== false) {
      obj.groupView = message.groupView;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ToggleWatchlistGroupViewRequest>, I>>(base?: I): ToggleWatchlistGroupViewRequest {
    return ToggleWatchlistGroupViewRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ToggleWatchlistGroupViewRequest>, I>>(
    object: I,
  ): ToggleWatchlistGroupViewRequest {
    const message = createBaseToggleWatchlistGroupViewRequest();
    message.groupView = object.groupView ?? false;
    return message;
  },
};

function createBaseWatchlistItems(): WatchlistItems {
  return { watchlistItems: [] };
}

export const WatchlistItems = {
  encode(message: WatchlistItems, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.watchlistItems) {
      Watchlist_WatchlistItem.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WatchlistItems {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWatchlistItems();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.watchlistItems.push(Watchlist_WatchlistItem.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WatchlistItems {
    return {
      watchlistItems: globalThis.Array.isArray(object?.watchlistItems)
        ? object.watchlistItems.map((e: any) => Watchlist_WatchlistItem.fromJSON(e))
        : [],
    };
  },

  toJSON(message: WatchlistItems): unknown {
    const obj: any = {};
    if (message.watchlistItems?.length) {
      obj.watchlistItems = message.watchlistItems.map((e) => Watchlist_WatchlistItem.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WatchlistItems>, I>>(base?: I): WatchlistItems {
    return WatchlistItems.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WatchlistItems>, I>>(object: I): WatchlistItems {
    const message = createBaseWatchlistItems();
    message.watchlistItems = object.watchlistItems?.map((e) => Watchlist_WatchlistItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUserWatchlists(): UserWatchlists {
  return { watchlists: [] };
}

export const UserWatchlists = {
  encode(message: UserWatchlists, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.watchlists) {
      Watchlist.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserWatchlists {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserWatchlists();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.watchlists.push(Watchlist.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserWatchlists {
    return {
      watchlists: globalThis.Array.isArray(object?.watchlists)
        ? object.watchlists.map((e: any) => Watchlist.fromJSON(e))
        : [],
    };
  },

  toJSON(message: UserWatchlists): unknown {
    const obj: any = {};
    if (message.watchlists?.length) {
      obj.watchlists = message.watchlists.map((e) => Watchlist.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserWatchlists>, I>>(base?: I): UserWatchlists {
    return UserWatchlists.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserWatchlists>, I>>(object: I): UserWatchlists {
    const message = createBaseUserWatchlists();
    message.watchlists = object.watchlists?.map((e) => Watchlist.fromPartial(e)) || [];
    return message;
  },
};

function createBaseReorderWatchlistRequest(): ReorderWatchlistRequest {
  return { watchlistItems: [] };
}

export const ReorderWatchlistRequest = {
  encode(message: ReorderWatchlistRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.watchlistItems) {
      Watchlist_WatchlistItem.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ReorderWatchlistRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReorderWatchlistRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.watchlistItems.push(Watchlist_WatchlistItem.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReorderWatchlistRequest {
    return {
      watchlistItems: globalThis.Array.isArray(object?.watchlistItems)
        ? object.watchlistItems.map((e: any) => Watchlist_WatchlistItem.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ReorderWatchlistRequest): unknown {
    const obj: any = {};
    if (message.watchlistItems?.length) {
      obj.watchlistItems = message.watchlistItems.map((e) => Watchlist_WatchlistItem.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ReorderWatchlistRequest>, I>>(base?: I): ReorderWatchlistRequest {
    return ReorderWatchlistRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReorderWatchlistRequest>, I>>(object: I): ReorderWatchlistRequest {
    const message = createBaseReorderWatchlistRequest();
    message.watchlistItems = object.watchlistItems?.map((e) => Watchlist_WatchlistItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseContainsWatchlistItemRequest(): ContainsWatchlistItemRequest {
  return { watchlistIds: [], securityOrExpression: "" };
}

export const ContainsWatchlistItemRequest = {
  encode(message: ContainsWatchlistItemRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.watchlistIds) {
      writer.uint32(10).string(v!);
    }
    if (message.securityOrExpression !== "") {
      writer.uint32(18).string(message.securityOrExpression);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ContainsWatchlistItemRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseContainsWatchlistItemRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.watchlistIds.push(reader.string());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.securityOrExpression = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ContainsWatchlistItemRequest {
    return {
      watchlistIds: globalThis.Array.isArray(object?.watchlistIds)
        ? object.watchlistIds.map((e: any) => globalThis.String(e))
        : [],
      securityOrExpression: isSet(object.securityOrExpression) ? globalThis.String(object.securityOrExpression) : "",
    };
  },

  toJSON(message: ContainsWatchlistItemRequest): unknown {
    const obj: any = {};
    if (message.watchlistIds?.length) {
      obj.watchlistIds = message.watchlistIds;
    }
    if (message.securityOrExpression !== "") {
      obj.securityOrExpression = message.securityOrExpression;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ContainsWatchlistItemRequest>, I>>(base?: I): ContainsWatchlistItemRequest {
    return ContainsWatchlistItemRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ContainsWatchlistItemRequest>, I>>(object: I): ContainsWatchlistItemRequest {
    const message = createBaseContainsWatchlistItemRequest();
    message.watchlistIds = object.watchlistIds?.map((e) => e) || [];
    message.securityOrExpression = object.securityOrExpression ?? "";
    return message;
  },
};

function createBaseContainsWatchlistItemResponse(): ContainsWatchlistItemResponse {
  return { records: {} };
}

export const ContainsWatchlistItemResponse = {
  encode(message: ContainsWatchlistItemResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    Object.entries(message.records).forEach(([key, value]) => {
      ContainsWatchlistItemResponse_RecordsEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).ldelim();
    });
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ContainsWatchlistItemResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseContainsWatchlistItemResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          const entry1 = ContainsWatchlistItemResponse_RecordsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.records[entry1.key] = entry1.value;
          }
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ContainsWatchlistItemResponse {
    return {
      records: isObject(object.records)
        ? Object.entries(object.records).reduce<{ [key: string]: boolean }>((acc, [key, value]) => {
          acc[key] = Boolean(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: ContainsWatchlistItemResponse): unknown {
    const obj: any = {};
    if (message.records) {
      const entries = Object.entries(message.records);
      if (entries.length > 0) {
        obj.records = {};
        entries.forEach(([k, v]) => {
          obj.records[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ContainsWatchlistItemResponse>, I>>(base?: I): ContainsWatchlistItemResponse {
    return ContainsWatchlistItemResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ContainsWatchlistItemResponse>, I>>(
    object: I,
  ): ContainsWatchlistItemResponse {
    const message = createBaseContainsWatchlistItemResponse();
    message.records = Object.entries(object.records ?? {}).reduce<{ [key: string]: boolean }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = globalThis.Boolean(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseContainsWatchlistItemResponse_RecordsEntry(): ContainsWatchlistItemResponse_RecordsEntry {
  return { key: "", value: false };
}

export const ContainsWatchlistItemResponse_RecordsEntry = {
  encode(message: ContainsWatchlistItemResponse_RecordsEntry, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ContainsWatchlistItemResponse_RecordsEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseContainsWatchlistItemResponse_RecordsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ContainsWatchlistItemResponse_RecordsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: ContainsWatchlistItemResponse_RecordsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ContainsWatchlistItemResponse_RecordsEntry>, I>>(
    base?: I,
  ): ContainsWatchlistItemResponse_RecordsEntry {
    return ContainsWatchlistItemResponse_RecordsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ContainsWatchlistItemResponse_RecordsEntry>, I>>(
    object: I,
  ): ContainsWatchlistItemResponse_RecordsEntry {
    const message = createBaseContainsWatchlistItemResponse_RecordsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
